import React from 'react';

import { refreshTokenRequest } from 'auth/msalConfig';

import { InteractionStatus, InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';

export const PageGuard: React.FC<oauth.PageGuardProps> = (props) => {
  useMsalAuthentication(InteractionType.Silent, refreshTokenRequest);

  const { children } = props;
  const { inProgress } = useMsal();

  if (inProgress === InteractionStatus.SsoSilent) {
    return <div />;
  }

  return children;
};
